
const posts = [
  {
    id: 1,
    title: "“Эко баатрууд” Байгаль танин мэдэхүй, гадаад орчин",
    href: "#",
    description:
      `Байгаль миний найз
      / Хог-Алт
      / Ургамлын хаан
      / Тэнгэрийн зааг 
      / Уяа зангилаа
      / Уулын дугуйтай аялал
      / Байгаль танин мэдэхүйн явган аялал
      / Уулын таг
      / Амьдын ертөнц
      / 100 жилийн амьдрал
      / Байгалийн дуран 
      `,
    imageUrl: "/baigali.png",
  },
  {
    id: 2,
    title: "”Монголчуудын бахархал” Зан заншил, өв соёл, уламжлал",
    href: "#",
    description:
      `Миний нутаг
      / Эх хэлний баялаг
      / Монгол гэр
      / Тоглоом, наадгай
      / Төрийн бэлгэдэл
      / Морин хуур
      / Бие биелэгээ
      / Нум сум харвах
      / Монгол ахуй
      / Ардын урлаг
      / Өв тээгчид
      `,
    imageUrl: "/zan-zanshil.png",
  },
  {
    id: 3,
    title: "”Хамтдаа бүтээцгээе” Амьдрах ухаан, бүтээлч сэтгэлгээ ",
    href: "#",
    description:
      `Керамик урлал
      / Шүрэн урлал
      / Утсан зангилаа
      / Модон урлал
      / Арьсан урлал
      / Чулууны инээмсэглэл
      / Санхүүгийн боловсрол
      / Техник сэтгэлгээ
      / Лего-“Шимт боловсрол”
      `,
    imageUrl: "/amidrah.png",
  },
  {
    id: 4,
    title: "“Би хэн бэ?” Хувь хүний чадвар, хөгжил, оролцоо ",
    href: "#",
    description:
      `Ой тогтоолт
      / Мэдрэмжийн хөгжил
      / Сахилга, дэг журам
      / Эрүүл мэнд нөхөн үржихүй
      / Харилцааны баялаг-хандлагын боловсрол
      / Цаг баримтлал
      / 5S
      / Зөв дадал-Зөв хүүхэд
      / Хууль-Бидний амьдралд
      `,
    imageUrl: "/huwi-hun.png",
  },
  {
    id: 5,
    title: "“Бид авьяастай” Соёл урлаг, спорт ",
    href: "#",
    description:
      `Кино боловсрол
      / Хэмнэл
      / Бүжиг (Чөлөөт, цэнгээнт)
      / Найрамдал медиа
      / Спорт өрөлт
      / Кендама
      / Крикет
      / Райгби
      / Гар бөмбөг
      / Сагсан бөмбөг
      / Хөл бөмбөг
      `,
    imageUrl: "/soyl.png",
  },
];

export default function Program() {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:max-w-4xl">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl italic">
            Төсөлт хөтөлбөрүүд
          </h2>
          <p className="mt-2 text-lg leading-8 text-gray-600">
          Зусланд амарч хөгжлийн хөтөлбөрт оролцож буй хүүхдүүд хувь хүний чадварыг хөгжүүлэхэд дэмжлэг үзүүлэх 5 чиглэлийн 40 гаруй төсөлтт хөтөлбөрөөс өөрийн сонирхолоор сонгон өөрийн оролцоотой хамрагдана. 
          </p>
          <div className="mt-16 space-y-20 lg:mt-20 lg:space-y-20">
            {posts.map((post) => (
              <article
                key={post.id}
                className="relative isolate flex flex-col gap-8 lg:flex-row"
              >
                <div className="relative aspect-[16/9] sm:aspect-[2/1] lg:aspect-square lg:w-64 lg:shrink-0">
                  <img
                    src={post.imageUrl}
                    alt=""
                    className="absolute inset-0 h-full w-full rounded-2xl bg-gray-50 object-cover"
                  />
                  <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
                </div>
                <div>
                  <div className="group relative max-w-md">
                    <h3 className="mt-3 text-lg font-semibold leading-6 text-[#003463] italic">
                      <a href={post.href}>
                        <span className="absolute inset-0 italic" />{" "}
                        {post.title}
                      </a>
                    </h3>
                    <ul className="mt-5 text-sm leading-6 text-[#003463] ml-4">
                      {post.description.split("/").map((item) => (
                        <li key={item} className="list-disc">
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
